// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AdminRolesForm-errorMessage-_kH0G {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}
.AdminRolesForm-space1-odANP {
	margin-bottom: 6px !important;
}
.AdminRolesForm-space2-oySC9 {
	margin-bottom: 12px !important;
}
.AdminRolesForm-space3-njpai {
	margin-bottom: 18px !important;
}
.AdminRolesForm-space4-WCBjd {
	margin-bottom: 24px !important;
}
.AdminRolesForm-space5-Qi7w7 {
	margin-bottom: 30px !important;
}
.AdminRolesForm-space6-nRGyZ {
	margin-bottom: 36px !important;
}
.AdminRolesForm-space7-o0NOL {
	margin-bottom: 42px !important;
}
.AdminRolesForm-space8-qtYQW {
	margin-bottom: 48px !important;
}
.AdminRolesForm-spaceTop1-o0z6i {
	margin-top: 6px !important;
}
.AdminRolesForm-spaceTop2-Gef36 {
	margin-top: 12px !important;
}
.AdminRolesForm-spaceTop3-xCIpA {
	margin-top: 18px !important;
}
.AdminRolesForm-spaceTop4-MueSN {
	margin-top: 24px !important;
}
.AdminRolesForm-spaceTop5-aoeyp {
	margin-top: 30px !important;
}
.AdminRolesForm-spaceTop6-zVrJc {
	margin-top: 36px !important;
}
.AdminRolesForm-spaceTop7-Ahr9R {
	margin-top: 42px !important;
}
.AdminRolesForm-spaceTop8-WPbH7 {
	margin-top: 48px !important;
}
.AdminRolesForm-noMargin-_JC8J {
	margin: 0px !important;
}
.AdminRolesForm-padding1-BPtvh {
	padding-bottom: 6px !important;
}
.AdminRolesForm-padding2-pWgKl {
	padding-bottom: 12px !important;
}
.AdminRolesForm-padding3-qwu6D {
	padding-bottom: 18px !important;
}
.AdminRolesForm-padding4-A4gyN {
	padding-bottom: 24px !important;
}
.AdminRolesForm-padding5-Czo9p {
	padding-bottom: 30px !important;
}
.AdminRolesForm-padding6-cwGag {
	padding-bottom: 36px !important;
}
.AdminRolesForm-padding7-gAkCf {
	padding-bottom: 42px !important;
}
.AdminRolesForm-paddingTop1-msHCg {
	padding-top: 6px !important;
}
.AdminRolesForm-paddingTop2-o_xMX {
	padding-top: 12px !important;
}
.AdminRolesForm-paddingTop3-YD2Vk {
	padding-top: 18px !important;
}
.AdminRolesForm-paddingTop4-QhB_1 {
	padding-top: 24px !important;
}
.AdminRolesForm-paddingTop5-elgGl {
	padding-top: 30px !important;
}
.AdminRolesForm-paddingTop6-VPH_M {
	padding-top: 36px !important;
}
.AdminRolesForm-paddingTop7-dWFzG {
	padding-top: 42px !important;
}
.AdminRolesForm-noPadding-pupcj {
	padding: 0px !important;
}
.AdminRolesForm-spaceMarginBottom0-EZ0QA {
	margin-bottom: 0;
}
.AdminRolesForm-textBold-tJvuQ {
	font-weight: 500 !important;
}
.AdminRolesForm-textBolder-tHj06 {
	font-weight: 700 !important;
}
.AdminRolesForm-textNormal-MvpIT {
	font-weight: normal !important;
}
/*New Design Text Colors */
.AdminRolesForm-textDarkBlue-l7Rhp {
	color: rgb(20, 39, 94) !important;
}
.AdminRolesForm-textLightBlue-l4MYh {
	color: rgb(57, 87, 106) !important;
}
.AdminRolesForm-textLightSandleGreen-Lzojr {
	color: rgb(76, 86, 41) !important;
}
.AdminRolesForm-textLightBrown-UEKIR {
	color: rgb(115, 79, 33) !important;
}
.AdminRolesForm-textMediumMaroon-kslNL {
	color: rgb(87, 37, 51) !important;
}
.AdminRolesForm-textBrown-m0AJq {
	color: rgb(160, 47, 24) !important;
}
.AdminRolesForm-textMaroon-nQMvm {
	color: rgb(155, 49, 67) !important;
}
.AdminRolesForm-textDarkBrown-ERPRG {
	color: rgb(83, 18, 16) !important;
}
.AdminRolesForm-textMediumBrown-GOLdl {
	color: rgb(142, 28, 10) !important;
}
.AdminRolesForm-textSkyBlue-ADv8s {
	color: rgb(37, 117, 141) !important;
}
.AdminRolesForm-textGray-LapmR {
	color: rgb(77, 65, 51) !important;
}
.AdminRolesForm-btn-DslZE,
.AdminRolesForm-btn-DslZE:focus {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	padding: 8px 12px 8px !important;
	width: auto;
	outline: 0 !important;
	border: 1px solid var(--primary-border) !important;
	border-radius: 6px !important;
	background: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
}
.AdminRolesForm-btn-DslZE:hover {
	background: var(--common-background-color) !important;
	outline: 0 !important;
	color: var(--white-text) !important;
	font-weight: 500;
}
.AdminRolesForm-btn-DslZE:hover img {
	-webkit-filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(104%) contrast(102%);
	        filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(104%) contrast(102%);
}
.AdminRolesForm-btnPrimary-xJokS,
.AdminRolesForm-btnPrimary-xJokS:focus {
	border-color: var(--btn-primary-bg) !important;
	background-color: var(--btn-primary-bg) !important;
	color: var(--white-text) !important;
	font-weight: 500;
}
.AdminRolesForm-btnPrimary-xJokS:hover {
	border-color: var(--btn-primary-bg-hover) !important;
	background-color: var(--btn-primary-bg-hover) !important;
	color: var(--white-text) !important;
	font-weight: 500;
}
.AdminRolesForm-btnPrimaryBorder-eTbVg,
.AdminRolesForm-btnPrimaryBorder-eTbVg:focus {
	border-color: var(--primary-border) !important;
	color: var(--common-text-color) !important;
	background-color: var(--btn-primary-color) !important;
	border-radius: 6px;
	padding: 8px 12px 8px !important;
	font-weight: 500;
	-webkit-box-shadow: inherit !important;
	        box-shadow: inherit !important;
}
.AdminRolesForm-btnPrimaryBorder-eTbVg:hover {
	border-color: var(--primary-border) !important;
	color: var(--common-text-color) !important;
	background-color: var(--btn-primary-color) !important;
	text-decoration: none !important;
	font-weight: 500;
}
.AdminRolesForm-btnSecondary-lyYVk,
.AdminRolesForm-btnSecondary-lyYVk:focus {
	border: 1px solid var(--primary-border) !important;
	background-color: var(--btn-secondary-bg) !important;
	color: var(--white-text) !important;
	padding: 8px 12px 8px !important;
	font-weight: 500;
	white-space: pre-line;
}
.AdminRolesForm-btnSecondary-lyYVk:hover {
	border: 1px solid var(--primary-border) !important;
	background-color: var(--btn-secondary-hover-bg) !important;
	color: var(--white-text) !important;
	font-weight: 500;
}
.AdminRolesForm-btnLink-gx71W,
.AdminRolesForm-btnLink-gx71W:focus {
	-webkit-box-sizing: border-box !important;
	        box-sizing: border-box !important;
	margin: 0 !important;
	width: auto !important;
	outline: 0 !important;
	background: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	font-size: inherit;
	border: 0px !important;
}
.AdminRolesForm-btnLink-gx71W:hover {
	background: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	outline: 0 !important;
	text-decoration: underline;
	font-weight: 500;
	word-wrap: break-word;
	line-height: 18px;
	letter-spacing: normal;
	border: 0px !important;
}
.AdminRolesForm-btnLinkPrimary-LNcYk,
.AdminRolesForm-btnLinkPrimary-LNcYk:focus {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
}
.AdminRolesForm-btnLinkPrimary-LNcYk:hover {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-text-color) !important;
	font-weight: 500;
}
.AdminRolesForm-btnLinkSecondary-wxdsH,
.AdminRolesForm-btnLinkSecondary-wxdsH:focus {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-link-color) !important;
	font-size: 16px;
	font-weight: 500;
	border-bottom: 1px solid var(--common-link-color) !important;
	border-radius: 0 !important;
	padding: 0 !important;
}
.AdminRolesForm-btnLinkSecondary-wxdsH:hover {
	background-color: var(--primary-white-bg) !important;
	color: var(--common-link-color) !important;
	font-weight: 500;
	text-decoration: none !important;
	border-bottom: 1px solid var(--common-link-color) !important;
}
.AdminRolesForm-searchFilterPopover-ve5MT {
	position: absolute;
	top: 57px;
	left: 0px;
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	display: inline-block;
	visibility: visible;
	background: var(--primary-white-bg);
	-o-border-image: initial;
	   border-image: initial;
	-webkit-box-shadow: 0px 3px 6px #00000029;
	        box-shadow: 0px 3px 6px #00000029;
	border-radius: 12px;
}
.AdminRolesForm-searchFilterPopoverFull-nnhK7 {
	z-index: 10;
	overflow-y: auto;
	overflow-x: hidden;
	white-space: normal;
	position: fixed;
	left: 0px;
	bottom: 0px;
	width: 66%;
	height: initial;
	-webkit-box-shadow: none;
	        box-shadow: none;
	visibility: visible;
	top: 148px;
	background: var(--primary-white-bg);
	border-radius: 4px;
	border-width: initial;
	border-style: none;
	border-color: initial;
	-o-border-image: initial;
	   border-image: initial;
}
.AdminRolesForm-searchFilterPopoverOverlay-aVGRz {
	position: fixed;
	height: 100vh;
	width: 100%;
	top: 64px;
	z-index: 2;
	background: rgba(255, 255, 255, 0.85);
	left: 0;
	right: 0;
	bottom: 0;
}
.AdminRolesForm-searchFilterPopoverContent-wHbkO {
	min-width: 370px;
	padding: 26px 26px 16px;
	height: 294px;
}
.AdminRolesForm-searchFilterCloseIcon-YDkO3 {
	font-size: 30px;
	color: var(--modalText-color);
}
.AdminRolesForm-searchFilterPopoverFooter-JfI3v {
	width: 100%;
	position: relative;
	line-height: 0;
}
.AdminRolesForm-displayTable-H4KB7 {
	display: table;
	width: 100%;
	vertical-align: middle;
}
.AdminRolesForm-displayTableRow-XfECD {
	display: table-row;
	vertical-align: middle;
}
.AdminRolesForm-displayTableCell-ddVbX {
	display: table-cell;
	vertical-align: middle;
}
.AdminRolesForm-displayInlineBlock-oe2eK {
	display: inline-block;
	vertical-align: top;
	white-space: normal;
}
.AdminRolesForm-fullWidth-dNsNf {
	width: 100% !important;
}
.AdminRolesForm-captionTitle-UaTiq {
	font-size: 18px;
}
.AdminRolesForm-showTabletSection-m3b4q {
	display: none !important;
}
.AdminRolesForm-incrementDecrementButton-YM1F0 {
	width: 100%;
	border: 1px solid var(--primary-border);
	border-radius: 6px;
	display: block;
	overflow: hidden;
	-webkit-appearance: none;
}
.AdminRolesForm-commonBorder-yhtAb {
	border: 1px solid transparent !important;
	color: var(--modalText-color) !important;
	-webkit-box-shadow: none !important;
	        box-shadow: none !important;
	border-radius: 60px !important;
	box-shadow: 0 1px 15px 3px #eeebeb !important;
	-webkit-box-shadow: 0 1px 15px 3px #eeebeb !important;
	-webkit-appearance: none !important;
}
.AdminRolesForm-textCenter-ta40B {
	text-align: center;
}
@media screen and (max-width: 768px) {
	.AdminRolesForm-searchFilterPopoverFull-nnhK7 {
		width: 100%;
		height: 100%;
		top: 0px;
		-webkit-box-shadow: none;
		        box-shadow: none;
		border: 1px solid var(--primary-white-bg);
		max-height: 100%;
		-webkit-overflow-scrolling: touch;
	}

	.AdminRolesForm-searchFilterPopoverContent-wHbkO {
		min-width: 320px;
		padding: 15px 15px 70px !important;
		height: 100%;
		min-height: 50vh;
		overflow: hidden;
		overflow-y: auto;
		-webkit-overflow-scrolling: touch;
	}

	.AdminRolesForm-searchFilterPopoverHeader-VNCqx {
		position: fixed;
		top: 0;
		z-index: 7;
		left: 0;
		right: 0;
		width: 100%;
		padding: 10px 15px;
		background: var(--primary-white-bg);
	}

	.AdminRolesForm-searchFilterPopoverFooter-JfI3v {
		font-weight: 600;
		position: fixed;
		top: 38%;
		left: 0;
		right: 0;
		background-color: transparent;
		z-index: 10;
	}

	.AdminRolesForm-textSize-L1USP {
		font-size: 20px;
		font-weight: 600;
		display: block;
		width: 100% !important;
		height: 45px;
	}
}
.AdminRolesForm-capitalizeText-pZBN6 {
	text-transform: capitalize;
}
.AdminRolesForm-hideBothTabletAndMobile-odQLX {
	display: inline-block;
}
@media (max-width: 1199px) {
	.AdminRolesForm-hideBothTabletAndMobile-odQLX {
		display: none !important;
	}
}
@media screen and (max-width: 350px) {
	.AdminRolesForm-btnFontsize-c4YZf {
		font-size: 12px !important;
	}
}
@media (max-width: 360px) {
	.AdminRolesForm-searchFilterCloseIcon-YDkO3 {
		font-size: 25px;
	}
}
.AdminRolesForm-transmissionBottom-VjAhb {
	padding-bottom: 21px !important;
}
.AdminRolesForm-marginTop20-ekAxd {
	margin-top: 35px;
}
.AdminRolesForm-marginRight15-VApRm {
	margin-right: 15px !important;
}
.AdminRolesForm-marginNone-UHFAV {
	margin: 0 !important;
}
.AdminRolesForm-paddingNone-Ly99p {
	padding: 0 !important;
}
.AdminRolesForm-infoPadding-Fd3ED {
	padding-right: 6px;
}
@media(min-width:768px) {
	.AdminRolesForm-pullRight-KZw4L {
		float: right;
	}
}
.AdminRolesForm-displayFlex-s0Jmy {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}
@media(max-width:767px) {

	.AdminRolesForm-displayFlex-s0Jmy {
		-webkit-box-pack: justify;
		    -ms-flex-pack: justify;
		        justify-content: space-between;
	}

	.AdminRolesForm-hideTabletSection-ouGAr {
		display: none !important;
	}

	.AdminRolesForm-showTabletSection-m3b4q {
		display: block !important;
	}
}
/*****************Apply Button Alignment Start **********************/
.AdminRolesForm-applyBtnDesktop-Wq0v4 {
	text-align: right;
}
.AdminRolesForm-applyBtn-TxgsV,
.AdminRolesForm-applyBtn-TxgsV:hover,
.AdminRolesForm-applyBtn-TxgsV:active,
.AdminRolesForm-applyBtn-TxgsV:focus {
	background-color: var(--common-background-color) !important;
	color: var(--white-text) !important;
	border-radius: 6px;
	text-decoration: none;
	padding: 9px 15px 10px;
	font-size: 16px;
}
@media screen and (max-width: 991px) {
	.AdminRolesForm-applyBtnDesktop-Wq0v4 {
		text-align: center;
	}

	.AdminRolesForm-applyBtnDesktopRight-UOVV_ {
		text-align: right !important;
	}

	.AdminRolesForm-applyBtnDesktopNoPaddingRight-W9LrD {
		padding-right: 0px !important;
	}
}
@media screen and (max-width: 767px) {
	.AdminRolesForm-searchFilterPopoverFooter-JfI3v {
		position: relative !important;
		top: inherit;
	}
}
/*****************Apply Button Alignment Start **********************/
/*************************** Header Modal Start **********************/
.AdminRolesForm-activeItem-c9cNI {
	padding: 15px;
	text-align: center;
	font-size: 16px;
	border-radius: 6px;
	cursor: pointer;
	border: 1px solid var(--primary-border);
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
}
.AdminRolesForm-activeItem-c9cNI:hover,
.AdminRolesForm-activeItem-c9cNI:focus,
.AdminRolesForm-activeItem-c9cNI:active {
	background-color: var(--common-background-color);
	color: var(--white-text);
	border-radius: 6px;
}
.AdminRolesForm-activeSection-XzamT:first-child {
	background-color: var(--common-background-color);
	color: var(--white-text);
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}
.AdminRolesForm-currencyAndLangGrid-EnGR2 {
	display: grid;
	grid-template-columns: repeat(5, 1fr);
	gap: 12px;
}
@media (max-width:767px) {
	.AdminRolesForm-currencyAndLangGrid-EnGR2 {
		grid-template-columns: repeat(2, 1fr);
	}
}
/*************************** Header Modal End **********************/
.AdminRolesForm-root-ho5r9 {
  padding-left: 0;
  padding-right: 0;
  min-height: 100vh;
  height: 100%;
  width: 100%;
  background: var(--common-gray-bg-color);
}
.AdminRolesForm-container-f6FSf {
  margin: 0 auto;
}
.AdminRolesForm-errorMessage-_kH0G {
  color: var(--alert-color)
}
.AdminRolesForm-btnPrimary-xJokS {
  padding: 6px 23px 3px 23px !important;
  font-size: 15px;
}
.AdminRolesForm-marginTop-iRuBd {
  margin-top: 20px;
}
.AdminRolesForm-labelFontWeightNormal-fYSRC {
  font-size: 16px;
  font-weight: 400;
  line-height: normal;
}
.AdminRolesForm-checkboxLabelContainer-SnJay {
  margin-bottom: 18px;
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/common.css","webpack://./src/components/siteadmin/AdminRolesForm/AdminRolesForm.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;ACRA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzLA;;CAEC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,gCAAgC;CAChC,WAAW;CACX,qBAAqB;CACrB,kDAAkD;CAClD,6BAA6B;CAC7B,8CAA8C;CAC9C,0CAA0C;CAC1C,gBAAgB;AACjB;AAEA;CACC,qDAAqD;CACrD,qBAAqB;CACrB,mCAAmC;CACnC,gBAAgB;AACjB;AAEA;CACC,qGAA6F;SAA7F,6FAA6F;AAC9F;AAEA;;CAEC,8CAA8C;CAC9C,kDAAkD;CAClD,mCAAmC;CACnC,gBAAgB;AACjB;AAEA;CACC,oDAAoD;CACpD,wDAAwD;CACxD,mCAAmC;CACnC,gBAAgB;AACjB;AAEA;;CAEC,8CAA8C;CAC9C,0CAA0C;CAC1C,qDAAqD;CACrD,kBAAkB;CAClB,gCAAgC;CAChC,gBAAgB;CAChB,sCAA8B;SAA9B,8BAA8B;AAC/B;AAEA;CACC,8CAA8C;CAC9C,0CAA0C;CAC1C,qDAAqD;CACrD,gCAAgC;CAChC,gBAAgB;AACjB;AAEA;;CAEC,kDAAkD;CAClD,oDAAoD;CACpD,mCAAmC;CACnC,gCAAgC;CAChC,gBAAgB;CAChB,qBAAqB;AACtB;AAEA;CACC,kDAAkD;CAClD,0DAA0D;CAC1D,mCAAmC;CACnC,gBAAgB;AACjB;AAEA;;CAEC,yCAAiC;SAAjC,iCAAiC;CACjC,oBAAoB;CACpB,sBAAsB;CACtB,qBAAqB;CACrB,8CAA8C;CAC9C,0CAA0C;CAC1C,gBAAgB;CAChB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,sBAAsB;AACvB;AAEA;CACC,8CAA8C;CAC9C,0CAA0C;CAC1C,qBAAqB;CACrB,0BAA0B;CAC1B,gBAAgB;CAChB,qBAAqB;CACrB,iBAAiB;CACjB,sBAAsB;CACtB,sBAAsB;AACvB;AAEA;;CAEC,oDAAoD;CACpD,0CAA0C;CAC1C,gBAAgB;AACjB;AAEA;CACC,oDAAoD;CACpD,0CAA0C;CAC1C,gBAAgB;AACjB;AAEA;;CAEC,oDAAoD;CACpD,0CAA0C;CAC1C,eAAe;CACf,gBAAgB;CAChB,4DAA4D;CAC5D,2BAA2B;CAC3B,qBAAqB;AACtB;AAEA;CACC,oDAAoD;CACpD,0CAA0C;CAC1C,gBAAgB;CAChB,gCAAgC;CAChC,4DAA4D;AAC7D;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,SAAS;CACT,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,qBAAqB;CACrB,mBAAmB;CACnB,mCAAmC;CACnC,wBAAqB;IAArB,qBAAqB;CACrB,yCAAiC;SAAjC,iCAAiC;CACjC,mBAAmB;AACpB;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,mBAAmB;CACnB,eAAe;CACf,SAAS;CACT,WAAW;CACX,UAAU;CACV,eAAe;CACf,wBAAgB;SAAhB,gBAAgB;CAChB,mBAAmB;CACnB,UAAU;CACV,mCAAmC;CACnC,kBAAkB;CAClB,qBAAqB;CACrB,kBAAkB;CAClB,qBAAqB;CACrB,wBAAqB;IAArB,qBAAqB;AACtB;AAEA;CACC,eAAe;CACf,aAAa;CACb,WAAW;CACX,SAAS;CACT,UAAU;CACV,qCAAqC;CACrC,OAAO;CACP,QAAQ;CACR,SAAS;AACV;AAEA;CACC,gBAAgB;CAChB,uBAAuB;CACvB,aAAa;AACd;AAEA;CACC,eAAe;CACf,6BAA6B;AAC9B;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,cAAc;AACf;AAEA;CACC,cAAc;CACd,WAAW;CACX,sBAAsB;AACvB;AAEA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;AAEA;CACC,qBAAqB;CACrB,mBAAmB;CACnB,mBAAmB;AACpB;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,wBAAwB;AACzB;AAEA;CACC,WAAW;CACX,uCAAuC;CACvC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,wBAAwB;AACzB;AAEA;CACC,wCAAwC;CACxC,wCAAwC;CACxC,mCAA2B;SAA3B,2BAA2B;CAC3B,8BAA8B;CAC9B,6CAA6C;CAC7C,qDAAqD;CACrD,mCAAmC;AACpC;AAGA;CACC,kBAAkB;AACnB;AAEA;CACC;EACC,WAAW;EACX,YAAY;EACZ,QAAQ;EACR,wBAAgB;UAAhB,gBAAgB;EAChB,yCAAyC;EACzC,gBAAgB;EAChB,iCAAiC;CAClC;;CAEA;EACC,gBAAgB;EAChB,kCAAkC;EAClC,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;CAClC;;CAEA;EACC,eAAe;EACf,MAAM;EACN,UAAU;EACV,OAAO;EACP,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,mCAAmC;CACpC;;CAEA;EACC,gBAAgB;EAChB,eAAe;EACf,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,6BAA6B;EAC7B,WAAW;CACZ;;CAEA;EACC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,YAAY;CACb;AACD;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,qBAAqB;AACtB;AAEA;CACC;EACC,wBAAwB;CACzB;AACD;AAEA;CACC;EACC,0BAA0B;CAC3B;AACD;AAEA;CACC;EACC,eAAe;CAChB;AACD;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,6BAA6B;AAC9B;AAEA;CACC,oBAAoB;AACrB;AAEA;CACC,qBAAqB;AACtB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC;EACC,YAAY;CACb;AACD;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,mBAAe;KAAf,eAAe;AAChB;AAEA;;CAEC;EACC,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;CAC/B;;CAEA;EACC,wBAAwB;CACzB;;CAEA;EACC,yBAAyB;CAC1B;AACD;AAEA,qEAAqE;AAErE;CACC,iBAAiB;AAClB;AAEA;;;;CAIC,2DAA2D;CAC3D,mCAAmC;CACnC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,eAAe;AAChB;AAEA;CACC;EACC,kBAAkB;CACnB;;CAEA;EACC,4BAA4B;CAC7B;;CAEA;EACC,6BAA6B;CAC9B;AACD;AAEA;CACC;EACC,6BAA6B;EAC7B,YAAY;CACb;AACD;AAEA,qEAAqE;AACrE,sEAAsE;AACtE;CACC,aAAa;CACb,kBAAkB;CAClB,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,uCAAuC;CACvC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;AAEA;;;CAGC,gDAAgD;CAChD,wBAAwB;CACxB,kBAAkB;AACnB;AAEA;CACC,gDAAgD;CAChD,wBAAwB;CACxB,uCAAuC;CACvC,kBAAkB;AACnB;AAEA;CACC,aAAa;CACb,qCAAqC;CACrC,SAAS;AACV;AAEA;CACC;EACC,qCAAqC;CACtC;AACD;AAEA,oEAAoE;ACrdpE;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,uCAAuC;AACzC;AAEA;EACE,cAAc;AAChB;AAEA;EACE;AACF;AAEA;EACE,qCAAqC;EACrC,eAAe;AACjB;AAEA;EACE,gBAAgB;AAClB;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AAEA;EACE,mBAAmB;AACrB","sourcesContent":[".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import 'utils.css';\n@import 'helpers.css';\n\n.btn,\n.btn:focus {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\tpadding: 8px 12px 8px !important;\n\twidth: auto;\n\toutline: 0 !important;\n\tborder: 1px solid var(--primary-border) !important;\n\tborder-radius: 6px !important;\n\tbackground: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n}\n\n.btn:hover {\n\tbackground: var(--common-background-color) !important;\n\toutline: 0 !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btn:hover img {\n\tfilter: invert(100%) sepia(0%) saturate(0%) hue-rotate(93deg) brightness(104%) contrast(102%);\n}\n\n.btnPrimary,\n.btnPrimary:focus {\n\tborder-color: var(--btn-primary-bg) !important;\n\tbackground-color: var(--btn-primary-bg) !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btnPrimary:hover {\n\tborder-color: var(--btn-primary-bg-hover) !important;\n\tbackground-color: var(--btn-primary-bg-hover) !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btnPrimaryBorder,\n.btnPrimaryBorder:focus {\n\tborder-color: var(--primary-border) !important;\n\tcolor: var(--common-text-color) !important;\n\tbackground-color: var(--btn-primary-color) !important;\n\tborder-radius: 6px;\n\tpadding: 8px 12px 8px !important;\n\tfont-weight: 500;\n\tbox-shadow: inherit !important;\n}\n\n.btnPrimaryBorder:hover {\n\tborder-color: var(--primary-border) !important;\n\tcolor: var(--common-text-color) !important;\n\tbackground-color: var(--btn-primary-color) !important;\n\ttext-decoration: none !important;\n\tfont-weight: 500;\n}\n\n.btnSecondary,\n.btnSecondary:focus {\n\tborder: 1px solid var(--primary-border) !important;\n\tbackground-color: var(--btn-secondary-bg) !important;\n\tcolor: var(--white-text) !important;\n\tpadding: 8px 12px 8px !important;\n\tfont-weight: 500;\n\twhite-space: pre-line;\n}\n\n.btnSecondary:hover {\n\tborder: 1px solid var(--primary-border) !important;\n\tbackground-color: var(--btn-secondary-hover-bg) !important;\n\tcolor: var(--white-text) !important;\n\tfont-weight: 500;\n}\n\n.btnLink,\n.btnLink:focus {\n\tbox-sizing: border-box !important;\n\tmargin: 0 !important;\n\twidth: auto !important;\n\toutline: 0 !important;\n\tbackground: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tfont-size: inherit;\n\tborder: 0px !important;\n}\n\n.btnLink:hover {\n\tbackground: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\toutline: 0 !important;\n\ttext-decoration: underline;\n\tfont-weight: 500;\n\tword-wrap: break-word;\n\tline-height: 18px;\n\tletter-spacing: normal;\n\tborder: 0px !important;\n}\n\n.btnLinkPrimary,\n.btnLinkPrimary:focus {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n}\n\n.btnLinkPrimary:hover {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-text-color) !important;\n\tfont-weight: 500;\n}\n\n.btnLinkSecondary,\n.btnLinkSecondary:focus {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-link-color) !important;\n\tfont-size: 16px;\n\tfont-weight: 500;\n\tborder-bottom: 1px solid var(--common-link-color) !important;\n\tborder-radius: 0 !important;\n\tpadding: 0 !important;\n}\n\n.btnLinkSecondary:hover {\n\tbackground-color: var(--primary-white-bg) !important;\n\tcolor: var(--common-link-color) !important;\n\tfont-weight: 500;\n\ttext-decoration: none !important;\n\tborder-bottom: 1px solid var(--common-link-color) !important;\n}\n\n.searchFilterPopover {\n\tposition: absolute;\n\ttop: 57px;\n\tleft: 0px;\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tdisplay: inline-block;\n\tvisibility: visible;\n\tbackground: var(--primary-white-bg);\n\tborder-image: initial;\n\tbox-shadow: 0px 3px 6px #00000029;\n\tborder-radius: 12px;\n}\n\n.searchFilterPopoverFull {\n\tz-index: 10;\n\toverflow-y: auto;\n\toverflow-x: hidden;\n\twhite-space: normal;\n\tposition: fixed;\n\tleft: 0px;\n\tbottom: 0px;\n\twidth: 66%;\n\theight: initial;\n\tbox-shadow: none;\n\tvisibility: visible;\n\ttop: 148px;\n\tbackground: var(--primary-white-bg);\n\tborder-radius: 4px;\n\tborder-width: initial;\n\tborder-style: none;\n\tborder-color: initial;\n\tborder-image: initial;\n}\n\n.searchFilterPopoverOverlay {\n\tposition: fixed;\n\theight: 100vh;\n\twidth: 100%;\n\ttop: 64px;\n\tz-index: 2;\n\tbackground: rgba(255, 255, 255, 0.85);\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n}\n\n.searchFilterPopoverContent {\n\tmin-width: 370px;\n\tpadding: 26px 26px 16px;\n\theight: 294px;\n}\n\n.searchFilterCloseIcon {\n\tfont-size: 30px;\n\tcolor: var(--modalText-color);\n}\n\n.searchFilterPopoverFooter {\n\twidth: 100%;\n\tposition: relative;\n\tline-height: 0;\n}\n\n.displayTable {\n\tdisplay: table;\n\twidth: 100%;\n\tvertical-align: middle;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\tvertical-align: middle;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n.displayInlineBlock {\n\tdisplay: inline-block;\n\tvertical-align: top;\n\twhite-space: normal;\n}\n\n.fullWidth {\n\twidth: 100% !important;\n}\n\n.captionTitle {\n\tfont-size: 18px;\n}\n\n.showTabletSection {\n\tdisplay: none !important;\n}\n\n.incrementDecrementButton {\n\twidth: 100%;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n\tdisplay: block;\n\toverflow: hidden;\n\t-webkit-appearance: none;\n}\n\n.commonBorder {\n\tborder: 1px solid transparent !important;\n\tcolor: var(--modalText-color) !important;\n\tbox-shadow: none !important;\n\tborder-radius: 60px !important;\n\tbox-shadow: 0 1px 15px 3px #eeebeb !important;\n\t-webkit-box-shadow: 0 1px 15px 3px #eeebeb !important;\n\t-webkit-appearance: none !important;\n}\n\n\n.textCenter {\n\ttext-align: center;\n}\n\n@media screen and (max-width: 768px) {\n\t.searchFilterPopoverFull {\n\t\twidth: 100%;\n\t\theight: 100%;\n\t\ttop: 0px;\n\t\tbox-shadow: none;\n\t\tborder: 1px solid var(--primary-white-bg);\n\t\tmax-height: 100%;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t.searchFilterPopoverContent {\n\t\tmin-width: 320px;\n\t\tpadding: 15px 15px 70px !important;\n\t\theight: 100%;\n\t\tmin-height: 50vh;\n\t\toverflow: hidden;\n\t\toverflow-y: auto;\n\t\t-webkit-overflow-scrolling: touch;\n\t}\n\n\t.searchFilterPopoverHeader {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tz-index: 7;\n\t\tleft: 0;\n\t\tright: 0;\n\t\twidth: 100%;\n\t\tpadding: 10px 15px;\n\t\tbackground: var(--primary-white-bg);\n\t}\n\n\t.searchFilterPopoverFooter {\n\t\tfont-weight: 600;\n\t\tposition: fixed;\n\t\ttop: 38%;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbackground-color: transparent;\n\t\tz-index: 10;\n\t}\n\n\t.textSize {\n\t\tfont-size: 20px;\n\t\tfont-weight: 600;\n\t\tdisplay: block;\n\t\twidth: 100% !important;\n\t\theight: 45px;\n\t}\n}\n\n.capitalizeText {\n\ttext-transform: capitalize;\n}\n\n.hideBothTabletAndMobile {\n\tdisplay: inline-block;\n}\n\n@media (max-width: 1199px) {\n\t.hideBothTabletAndMobile {\n\t\tdisplay: none !important;\n\t}\n}\n\n@media screen and (max-width: 350px) {\n\t.btnFontsize {\n\t\tfont-size: 12px !important;\n\t}\n}\n\n@media (max-width: 360px) {\n\t.searchFilterCloseIcon {\n\t\tfont-size: 25px;\n\t}\n}\n\n.transmissionBottom {\n\tpadding-bottom: 21px !important;\n}\n\n.marginTop20 {\n\tmargin-top: 35px;\n}\n\n.marginRight15 {\n\tmargin-right: 15px !important;\n}\n\n.marginNone {\n\tmargin: 0 !important;\n}\n\n.paddingNone {\n\tpadding: 0 !important;\n}\n\n.infoPadding {\n\tpadding-right: 6px;\n}\n\n@media(min-width:768px) {\n\t.pullRight {\n\t\tfloat: right;\n\t}\n}\n\n.displayFlex {\n\tdisplay: flex;\n\talign-items: center;\n\tflex-wrap: wrap;\n}\n\n@media(max-width:767px) {\n\n\t.displayFlex {\n\t\tjustify-content: space-between;\n\t}\n\n\t.hideTabletSection {\n\t\tdisplay: none !important;\n\t}\n\n\t.showTabletSection {\n\t\tdisplay: block !important;\n\t}\n}\n\n/*****************Apply Button Alignment Start **********************/\n\n.applyBtnDesktop {\n\ttext-align: right;\n}\n\n.applyBtn,\n.applyBtn:hover,\n.applyBtn:active,\n.applyBtn:focus {\n\tbackground-color: var(--common-background-color) !important;\n\tcolor: var(--white-text) !important;\n\tborder-radius: 6px;\n\ttext-decoration: none;\n\tpadding: 9px 15px 10px;\n\tfont-size: 16px;\n}\n\n@media screen and (max-width: 991px) {\n\t.applyBtnDesktop {\n\t\ttext-align: center;\n\t}\n\n\t.applyBtnDesktopRight {\n\t\ttext-align: right !important;\n\t}\n\n\t.applyBtnDesktopNoPaddingRight {\n\t\tpadding-right: 0px !important;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.searchFilterPopoverFooter {\n\t\tposition: relative !important;\n\t\ttop: inherit;\n\t}\n}\n\n/*****************Apply Button Alignment Start **********************/\n/*************************** Header Modal Start **********************/\n.activeItem {\n\tpadding: 15px;\n\ttext-align: center;\n\tfont-size: 16px;\n\tborder-radius: 6px;\n\tcursor: pointer;\n\tborder: 1px solid var(--primary-border);\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n}\n\n.activeItem:hover,\n.activeItem:focus,\n.activeItem:active {\n\tbackground-color: var(--common-background-color);\n\tcolor: var(--white-text);\n\tborder-radius: 6px;\n}\n\n.activeSection:first-child {\n\tbackground-color: var(--common-background-color);\n\tcolor: var(--white-text);\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.currencyAndLangGrid {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(5, 1fr);\n\tgap: 12px;\n}\n\n@media (max-width:767px) {\n\t.currencyAndLangGrid {\n\t\tgrid-template-columns: repeat(2, 1fr);\n\t}\n}\n\n/*************************** Header Modal End **********************/","@import '../../../components/common.css';\n\n.root {\n  padding-left: 0;\n  padding-right: 0;\n  min-height: 100vh;\n  height: 100%;\n  width: 100%;\n  background: var(--common-gray-bg-color);\n}\n\n.container {\n  margin: 0 auto;\n}\n\n.errorMessage {\n  color: var(--alert-color)\n}\n\n.btnPrimary {\n  padding: 6px 23px 3px 23px !important;\n  font-size: 15px;\n}\n\n.marginTop {\n  margin-top: 20px;\n}\n\n.labelFontWeightNormal {\n  font-size: 16px;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.checkboxLabelContainer {\n  margin-bottom: 18px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `AdminRolesForm-errorMessage-_kH0G`,
	"space1": `AdminRolesForm-space1-odANP`,
	"space2": `AdminRolesForm-space2-oySC9`,
	"space3": `AdminRolesForm-space3-njpai`,
	"space4": `AdminRolesForm-space4-WCBjd`,
	"space5": `AdminRolesForm-space5-Qi7w7`,
	"space6": `AdminRolesForm-space6-nRGyZ`,
	"space7": `AdminRolesForm-space7-o0NOL`,
	"space8": `AdminRolesForm-space8-qtYQW`,
	"spaceTop1": `AdminRolesForm-spaceTop1-o0z6i`,
	"spaceTop2": `AdminRolesForm-spaceTop2-Gef36`,
	"spaceTop3": `AdminRolesForm-spaceTop3-xCIpA`,
	"spaceTop4": `AdminRolesForm-spaceTop4-MueSN`,
	"spaceTop5": `AdminRolesForm-spaceTop5-aoeyp`,
	"spaceTop6": `AdminRolesForm-spaceTop6-zVrJc`,
	"spaceTop7": `AdminRolesForm-spaceTop7-Ahr9R`,
	"spaceTop8": `AdminRolesForm-spaceTop8-WPbH7`,
	"noMargin": `AdminRolesForm-noMargin-_JC8J`,
	"padding1": `AdminRolesForm-padding1-BPtvh`,
	"padding2": `AdminRolesForm-padding2-pWgKl`,
	"padding3": `AdminRolesForm-padding3-qwu6D`,
	"padding4": `AdminRolesForm-padding4-A4gyN`,
	"padding5": `AdminRolesForm-padding5-Czo9p`,
	"padding6": `AdminRolesForm-padding6-cwGag`,
	"padding7": `AdminRolesForm-padding7-gAkCf`,
	"paddingTop1": `AdminRolesForm-paddingTop1-msHCg`,
	"paddingTop2": `AdminRolesForm-paddingTop2-o_xMX`,
	"paddingTop3": `AdminRolesForm-paddingTop3-YD2Vk`,
	"paddingTop4": `AdminRolesForm-paddingTop4-QhB_1`,
	"paddingTop5": `AdminRolesForm-paddingTop5-elgGl`,
	"paddingTop6": `AdminRolesForm-paddingTop6-VPH_M`,
	"paddingTop7": `AdminRolesForm-paddingTop7-dWFzG`,
	"noPadding": `AdminRolesForm-noPadding-pupcj`,
	"spaceMarginBottom0": `AdminRolesForm-spaceMarginBottom0-EZ0QA`,
	"textBold": `AdminRolesForm-textBold-tJvuQ`,
	"textBolder": `AdminRolesForm-textBolder-tHj06`,
	"textNormal": `AdminRolesForm-textNormal-MvpIT`,
	"textDarkBlue": `AdminRolesForm-textDarkBlue-l7Rhp`,
	"textLightBlue": `AdminRolesForm-textLightBlue-l4MYh`,
	"textLightSandleGreen": `AdminRolesForm-textLightSandleGreen-Lzojr`,
	"textLightBrown": `AdminRolesForm-textLightBrown-UEKIR`,
	"textMediumMaroon": `AdminRolesForm-textMediumMaroon-kslNL`,
	"textBrown": `AdminRolesForm-textBrown-m0AJq`,
	"textMaroon": `AdminRolesForm-textMaroon-nQMvm`,
	"textDarkBrown": `AdminRolesForm-textDarkBrown-ERPRG`,
	"textMediumBrown": `AdminRolesForm-textMediumBrown-GOLdl`,
	"textSkyBlue": `AdminRolesForm-textSkyBlue-ADv8s`,
	"textGray": `AdminRolesForm-textGray-LapmR`,
	"btn": `AdminRolesForm-btn-DslZE`,
	"btnPrimary": `AdminRolesForm-btnPrimary-xJokS`,
	"btnPrimaryBorder": `AdminRolesForm-btnPrimaryBorder-eTbVg`,
	"btnSecondary": `AdminRolesForm-btnSecondary-lyYVk`,
	"btnLink": `AdminRolesForm-btnLink-gx71W`,
	"btnLinkPrimary": `AdminRolesForm-btnLinkPrimary-LNcYk`,
	"btnLinkSecondary": `AdminRolesForm-btnLinkSecondary-wxdsH`,
	"searchFilterPopover": `AdminRolesForm-searchFilterPopover-ve5MT`,
	"searchFilterPopoverFull": `AdminRolesForm-searchFilterPopoverFull-nnhK7`,
	"searchFilterPopoverOverlay": `AdminRolesForm-searchFilterPopoverOverlay-aVGRz`,
	"searchFilterPopoverContent": `AdminRolesForm-searchFilterPopoverContent-wHbkO`,
	"searchFilterCloseIcon": `AdminRolesForm-searchFilterCloseIcon-YDkO3`,
	"searchFilterPopoverFooter": `AdminRolesForm-searchFilterPopoverFooter-JfI3v`,
	"displayTable": `AdminRolesForm-displayTable-H4KB7`,
	"displayTableRow": `AdminRolesForm-displayTableRow-XfECD`,
	"displayTableCell": `AdminRolesForm-displayTableCell-ddVbX`,
	"displayInlineBlock": `AdminRolesForm-displayInlineBlock-oe2eK`,
	"fullWidth": `AdminRolesForm-fullWidth-dNsNf`,
	"captionTitle": `AdminRolesForm-captionTitle-UaTiq`,
	"showTabletSection": `AdminRolesForm-showTabletSection-m3b4q`,
	"incrementDecrementButton": `AdminRolesForm-incrementDecrementButton-YM1F0`,
	"commonBorder": `AdminRolesForm-commonBorder-yhtAb`,
	"textCenter": `AdminRolesForm-textCenter-ta40B`,
	"searchFilterPopoverHeader": `AdminRolesForm-searchFilterPopoverHeader-VNCqx`,
	"textSize": `AdminRolesForm-textSize-L1USP`,
	"capitalizeText": `AdminRolesForm-capitalizeText-pZBN6`,
	"hideBothTabletAndMobile": `AdminRolesForm-hideBothTabletAndMobile-odQLX`,
	"btnFontsize": `AdminRolesForm-btnFontsize-c4YZf`,
	"transmissionBottom": `AdminRolesForm-transmissionBottom-VjAhb`,
	"marginTop20": `AdminRolesForm-marginTop20-ekAxd`,
	"marginRight15": `AdminRolesForm-marginRight15-VApRm`,
	"marginNone": `AdminRolesForm-marginNone-UHFAV`,
	"paddingNone": `AdminRolesForm-paddingNone-Ly99p`,
	"infoPadding": `AdminRolesForm-infoPadding-Fd3ED`,
	"pullRight": `AdminRolesForm-pullRight-KZw4L`,
	"displayFlex": `AdminRolesForm-displayFlex-s0Jmy`,
	"hideTabletSection": `AdminRolesForm-hideTabletSection-ouGAr`,
	"applyBtnDesktop": `AdminRolesForm-applyBtnDesktop-Wq0v4`,
	"applyBtn": `AdminRolesForm-applyBtn-TxgsV`,
	"applyBtnDesktopRight": `AdminRolesForm-applyBtnDesktopRight-UOVV_`,
	"applyBtnDesktopNoPaddingRight": `AdminRolesForm-applyBtnDesktopNoPaddingRight-W9LrD`,
	"activeItem": `AdminRolesForm-activeItem-c9cNI`,
	"activeSection": `AdminRolesForm-activeSection-XzamT`,
	"currencyAndLangGrid": `AdminRolesForm-currencyAndLangGrid-EnGR2`,
	"root": `AdminRolesForm-root-ho5r9`,
	"container": `AdminRolesForm-container-f6FSf`,
	"marginTop": `AdminRolesForm-marginTop-iRuBd`,
	"labelFontWeightNormal": `AdminRolesForm-labelFontWeightNormal-fYSRC`,
	"checkboxLabelContainer": `AdminRolesForm-checkboxLabelContainer-SnJay`
};
module.exports = ___CSS_LOADER_EXPORT___;
